module.exports = __webpack_public_path__ + "static/media/picture.1fe2e204.svg";